/* eslint-disable array-callback-return */
/* eslint-disable react/no-this-in-sfc */
import Colors from '__designkit__/common/colors';
import Icon from '__designkit__/icon/Icon';
import JDFullModal from 'components/_v2/_common/modals/JDFullModal';
import styled from 'styled-components';
import { FC, useEffect, useState } from 'react';
import { SpaceValue } from '__pc__/constant/v2Design/SpaceType';
import V2Text from '__pc__/components/common/v2Design/text';
import { V2TextOption } from '__pc__/constant/v2Design/V2TextType';
import { V2BackgroundColors } from '__pc__/constant/v2Design/Colors/V2BackgroundColors';
import { V2BorderColors } from '__pc__/constant/v2Design/Colors/V2BorderColors';
import V2Button from '__pc__/components/common/v2Design/button';
import { V2ButtonOption } from '__pc__/constant/v2Design/V2ButtonType';
import MatchMessageStore from 'models/MatchMessageStore';
import { injectStore } from 'models/store';
import { inject, observer } from 'mobx-react';
import { DateFormatYYYYMMDDWithDot, overDateNow } from 'utils/DateUtils';
import { MatchingMessageResponseType } from 'interfaces/rqrs/IMatchingMessageListRs';
import MatchApplyStatusMessageTab from './MatchApplyStatusMessageTab';
import MatchApplyNewDeniedModal from './MatchApplyNewDeniedModal';
import MatchApplyAcceptModal from './MatchApplyAcceptModal';

const Header = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 64px;
  padding: ${SpaceValue.M}px;
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${Colors.WHITE_100};
  z-index: 10000;
`;

const HeaderFrame = styled.div`
    display: flex;
    flex-direction: column;
    padding: 88px ${SpaceValue.L}px ${SpaceValue.M}px ${SpaceValue.L}px;
    gap:${SpaceValue.L}px;
    .icon-title{
        display: flex;
        gap:${SpaceValue.L}px;
        .icon{
            width: 48px;
            height: 48px;
            background-color: ${Colors.CG_60};
        }
        .title-desc{
            display: flex;
            flex-direction: column;
            gap:4px;
        }
    }
    .response-section{
        display: flex;
        gap:${SpaceValue.M}px;
        .divider{
            width: 1px;
            height: 12px;
            background-color: ${V2BorderColors.default};
        }
    }
    .response-reject{
        display: flex;
        flex-direction: column;
        gap:4px;
    }
`;
const BottomButtonFrame = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${V2BackgroundColors.surface_default};
  padding:0 ${SpaceValue.L}px ${SpaceValue.XL}px ${SpaceValue.L}px;
  gap: ${SpaceValue.XS}px;
    position: fixed;
    bottom: calc(env(safe-area-inset-bottom));
    width: 100%;
::before{
  content: '';
  position: absolute;
  top: -24px;
  left: 0;
  width: 100%;
  height: 24px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 100%);
}
`;
interface IMatchApplyStatusMessageModalProps {
  matchMessageStore?: MatchMessageStore;
}

const MatchApplyStatusMessageModal: FC<IMatchApplyStatusMessageModalProps> = ({ matchMessageStore = new MatchMessageStore() }) => {
  const [isDeniedModalOpen, setIsDeniedModalOpen] = useState(false);
  const [isAcceptModalOpen, setIsAcceptModalOpen] = useState(false);
  useEffect(() => {
    const init = async () => {
      matchMessageStore.init();
      await matchMessageStore.loadMatchingMessage(matchMessageStore.matchingSn);
    };
    if (matchMessageStore.isHdotXOpen) init();
  }, [matchMessageStore.isHdotXOpen]);

  if (!matchMessageStore.isHdotXOpen) return <></>;

  return (
    <JDFullModal>
      <Header>
        <Icon name='large-arrow-left' size={32} color={Colors.JOBDA_BLACK} onClick={() => matchMessageStore.close()} />
      </Header>
      <HeaderFrame>
        <div className='icon-title'>
          <img src={matchMessageStore.matchingMessage?.companyLogoUrl} alt='companyLogo' className='icon' />
          <div className='title-desc'>
            <div className='title'>
              <V2Text fontStyle={V2TextOption.fontStyle.body_1_sb} color={V2TextOption.color.strong}>
                {matchMessageStore.matchingMessage?.title}
              </V2Text>
              <V2Text fontStyle={V2TextOption.fontStyle.body_2_m} color={V2TextOption.color.default}>
                {matchMessageStore.matchingMessage?.companyName}
              </V2Text>
            </div>
          </div>
        </div>
        {
          matchMessageStore.matchingMessage?.responseType === MatchingMessageResponseType.ACCEPTED
            ? (
              <div className='response-section'>
                <V2Text fontStyle={V2TextOption.fontStyle.body_2_m} color={V2TextOption.color.subtle}>
                  {`제안 수락: ${DateFormatYYYYMMDDWithDot(matchMessageStore.matchingMessage?.responseDateTime || '')}`}
                </V2Text>
              </div>
            )
            : matchMessageStore.matchingMessage?.responseType === MatchingMessageResponseType.REJECTED
              ? (
                <div className='response-reject'>
                  <V2Text fontStyle={V2TextOption.fontStyle.body_2_m} color={V2TextOption.color.subtle}>
                    {`제안 거절: ${DateFormatYYYYMMDDWithDot(matchMessageStore.matchingMessage?.responseDateTime || '')}`}
                  </V2Text>
                  <V2Text fontStyle={V2TextOption.fontStyle.body_2_m} color={V2TextOption.color.subtlest}>
                    {matchMessageStore.matchingMessage?.rejectReason}
                  </V2Text>
                </div>
              )
              : matchMessageStore.matchingMessage?.responseType === MatchingMessageResponseType.UNANSWERED
              && matchMessageStore.matchingMessage.responseLimitDateTime
              && overDateNow(matchMessageStore.matchingMessage.responseLimitDateTime)
                ? (
                  <div className='response-reject'>
                    <V2Text fontStyle={V2TextOption.fontStyle.body_2_m} color={V2TextOption.color.subtle}>
                      제안 미응답
                    </V2Text>
                  </div>
                )
                : (
                  <div className='response-section'>
                    <V2Text fontStyle={V2TextOption.fontStyle.body_2_m} color={V2TextOption.color.subtle}>
                      {`제안 받음: ${DateFormatYYYYMMDDWithDot(matchMessageStore.matchingMessage?.offerReceivedDateTime || '')}`}
                    </V2Text>
                    <div className='divider' />
                    <V2Text fontStyle={V2TextOption.fontStyle.body_2_m} color={V2TextOption.color.subtle}>
                      {`응답 기한: ${DateFormatYYYYMMDDWithDot(matchMessageStore.matchingMessage?.responseLimitDateTime || '')}`}
                    </V2Text>
                  </div>
                )
        }

      </HeaderFrame>
      <MatchApplyStatusMessageTab />
      <BottomButtonFrame>
        <V2Button
          type={V2ButtonOption.type.Fill}
          fontStyle={V2ButtonOption.fontStyle.body_1_sb}
          color={V2ButtonOption.color.inverse}
          fill={V2ButtonOption.fillType.brand_strong_default}
          buttonProps={{ onClick: () => setIsAcceptModalOpen(true) }}
        >
          수락하기
        </V2Button>
        <V2Button
          type={V2ButtonOption.type.OutLine}
          fontStyle={V2ButtonOption.fontStyle.body_1_sb}
          color={V2ButtonOption.color.subtle}
          fill={V2ButtonOption.fillType.neutral_subtle_default}
          buttonProps={{ onClick: () => setIsDeniedModalOpen(true) }}
        >
          거절하기
        </V2Button>
      </BottomButtonFrame>
      {
        isDeniedModalOpen && (
          <MatchApplyNewDeniedModal
            onClickClose={() => setIsDeniedModalOpen(false)}
            isOpen={isDeniedModalOpen}
          />
        )
      }
      {
        isAcceptModalOpen && (
          <MatchApplyAcceptModal
            onClickClose={() => setIsAcceptModalOpen(false)}
            isOpen={isAcceptModalOpen}
          />
        )
      }
    </JDFullModal>
  );
};

export default inject(injectStore.matchMessageStore)(observer(MatchApplyStatusMessageModal));
